<template>
  <transition name="showBox">
    <div
      class="cart"
      v-show="cartVisible"
    >
      <div
        class="cart-mask"
        @click="closeCart"
      ></div>
      <transition name="right">
        <div
          class="cart-content"
          v-show="cartVisible"
        >
          <div class="closeCart">
            <a-icon
              @click="closeCart()"
              type="close"
            />
          </div>
          <h3 class="cbs-title"><i class="iconfont icon-shopping"></i>{{$t('cart.title')}}</h3>
          <ul class="list">
            <a-empty
              v-if="cartList.length === 0"
              description="購物袋為空！"
            />
            <li
              class="list-item"
              v-for="(item) in cartList"
              :key="item.couponId"
            >
              <!-- <div
                class="item-box"
                @touchstart="touchStart($event,index)"
                @touchmove="touchMove($event,index)"
                @touchend="touchEnd($event,index)"
              > -->
              <div class="item-box">
                <div class="item-img">
                  <img
                    :src="item.detailBannerUrl || item.couponPromotionBannerUrl"
                    alt=""
                  >
                </div>
                <div class="item-body">
                  <div class="item-info">
                    <span class="item-title">{{ item.shortDescription }}</span>
                    <span class="item-time">
                      Validity Period：{{item.effectiveStartDate | ValidityDateFormat}} - {{item.effectiveEndDate | ValidityDateFormat}}
                    </span>
                  </div>
                  <div class="item-price-container">
                    <div class="item-quantity">
                      <a-button
                        icon="minus"
                        size="small"
                        :disabled="item.quantity === 1"
                        @click="reduceCart(item)"
                      />
                      {{ item.quantity }}
                      <a-button
                        icon="plus"
                        size="small"
                        @click="increaseCart(item)"
                      />
                    </div>
                    <div class="item-price">${{item.price}}</div>
                  </div>
                </div>
              </div>
              <button
                class="item-pc-remove"
                @click="removeCart({id:item.couponId})"
              >X</button>
              <!-- <button
                class="list-mp-remove"
                @click="handleRemoveCart({id:item.couponId})"
              >删除</button> -->
            </li>
          </ul>
          <!-- <div class="cart-discount">
            <div class="discount-left">
              <span>{{$t('cart.discountText')}}</span>
              <button disabled>{{$t('cart.determine')}}</button>
            </div>
            <div class="discount-right">
              <span>{{$t('cart.discount')}}:</span>
              <span class="price">-$0</span>
            </div>
          </div> -->
          <p class="cart-totalPrice">
            <span>{{$t('cart.totalPrice')}}:</span>
            <span class="price">${{totalPrice}}</span>
          </p>
          <button
            class="purchaseBtn"
            :disabled="cartList.length === 0"
            @click="goOrderPage"
          >
            <i class="iconfont icon-shopping"></i>{{$t('cart.purchase')}}
          </button>
        </div>
      </transition>
    </div>
  </transition>

</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    cartVisible: {
      type: [Boolean, String],
      default: false
    }
  },
  data () {
    return {
      // 滑动事件起始点
      // mouseStart: [],
      // 所有购物车列表dom元素
      // domList: null,
      // 删除按钮显示与隐藏
      // removeVisible: false,
      // 删除按钮显示的角标
      // removeVisibleItem: null
    }
  },
  methods: {
    ...mapMutations('cart', [
      'removeCart',
      'increaseCart',
      'reduceCart'
    ]),
    ...mapMutations('order', [
      'setOrder'
    ]),
    closeCart () {
      this.$emit('update:cartVisible', false)
    },
    goOrderPage () {
      const arr = JSON.parse(JSON.stringify(this.cartList))
      this.setOrder(arr)
      this.$emit('update:cartVisible', false)
      this.$nextTick(() => {
        this.$router.push({ name: 'order' })
      })
      /* else {
        this.$bus.$emit('showLogin', true, 'order', () => {
          this.setOrder(arr)
          this.$emit('update:cartVisible', false)
        })
      } */
    }
    /*     touchStart (e, index) {
          console.log('touchStart....', index)
          this.domList = document.querySelectorAll('.list-item')
          if (this.removeVisible) {
            const itemBody = this.domList[this.removeVisibleItem].querySelector('.item-box')
            const itemRemove = this.domList[this.removeVisibleItem].querySelector('.list-mp-remove')
            itemBody.style.transition = 'all 0.4s'
            itemRemove.style.transition = 'all 0.4s'
            itemBody.style.transform = 'translateX(0px)'
            itemRemove.style.width = '0px'
            setTimeout(() => {
              this.removeVisible = false
              this.removeVisibleItem = null
              itemBody.style.transition = 'none'
              itemRemove.style.transition = 'none'
            }, 400)
            return
          }
          this.mouseStart[index] = e.targetTouches[0].clientX
        },
        touchMove (e, index) {
          console.log('touchMove....', index)
          const mouseX = e.changedTouches[0].clientX
          // 计算移动的距离
          const move = mouseX - this.mouseStart[index]
          const itemBody = this.domList[index].querySelector('.item-box')
          const itemRemove = this.domList[index].querySelector('.list-mp-remove')
          if (move > 0) {
            itemBody.style.transform = 'translateX(0px)'
            itemRemove.style.width = '0px'
          } else {
            itemBody.style.transform = `translateX(${move}px)`
            itemRemove.style.width = -move + 'px'
          }
        },
        touchEnd (e, index) {
          console.log('touchEnd....', index)
          const mouseX = e.changedTouches[0].clientX
          const itemBody = this.domList[index].querySelector('.item-box')
          const itemRemove = this.domList[index].querySelector('.list-mp-remove')
          if (this.mouseStart[index] - mouseX >= 50) {
            itemBody.style.transform = 'translateX(-84px)'
            itemRemove.style.width = '84px'
            this.removeVisible = true
            this.removeVisibleItem = index
          } else {
            itemBody.style.transform = 'translateX(0px)'
            itemRemove.style.width = '0px'
          }
        }, 
        handleRemoveCart (id) {
          this.removeCart(id)
        }, */
  },
  computed: {
    ...mapState({
      cartList: state => state.cart.cartList,
    }),
    ...mapGetters('cart', {
      totalPrice: 'getTotal'
    }),
  },
  watch: {
    cartVisible (newVal, oldVal) {
      if (newVal) {
        // 让 body 高度 = 100%,超出隐藏
        document.body.classList.add('hidden-module-cart')
      } else {
        // 取消上面操作
        document.body.classList.remove('hidden-module-cart')
      }
    }
  },
  filters: {
    ValidityDateFormat (data) {
      return data.split('-').reverse().join('/')
    }
  }
}
</script>

<style lang="scss" scoped>
$btn-color: #d4517e;
$btn-hover-color: #c82333;

.cart {
  position: fixed;
  top: 0;
  right: 0;
  text-align: left;
  z-index: 1000;
  width: 100%;
  height: 100%;
  .cart-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 122, 170, 0.7);
    z-index: 10;
  }
  .cart-content {
    position: absolute;
    right: 0;
    width: 45%;
    padding: 24px;
    height: 100%;
    background-color: #fff;
    z-index: 100;
    overflow: auto;
    @media screen and (max-width: 768px) {
      width: 90%;
      padding: 12px;
    }
    .closeCart {
      text-align: right;
      color: #949494;
      margin-bottom: 35px;
      @media (max-width: 768px) {
        margin-bottom: 12px;
      }
      > i {
        cursor: pointer;
      }
    }
  }
}

.cbs-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  > i {
    margin-right: 5px;
    font-size: 24px;
  }
}

.list {
  padding: 0;
  margin: 0;
  .list-item {
    position: relative;
    padding: 10px 0;
    list-style: none;
    border-top: 1px solid #e5e5e5;
    .item-box {
      display: flex;
    }
    .item-img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      margin-right: 25px;
      @media (max-width: 992px) {
        margin-right: 10px;
      }
      @media (max-width: 768px) {
        margin-right: 5px;
      }
      > img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .item-body {
      display: flex;
      justify-content: space-between;
      flex: 1;
      .item-info {
        display: flex;
        flex-direction: column;
        .item-title {
          font-size: 18px;
          color: #000;
        }
        .item-time {
          margin-top: 5px;
          font-size: 14px;
          color: #b3b3b3;
        }
      }
      .item-price-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 0 0 150px;
        @media (max-width: 768px) {
          flex: 0 0 125px;
        }
        .item-quantity {
          display: flex;
          align-items: center;
          > button {
            margin: 0 5px;
          }
        }
      }
    }
    .item-pc-remove,
    .list-mp-remove {
      position: absolute;
      top: 0;
      right: 0;
      border: none;
      outline: none;
      overflow: hidden;
    }
    .item-pc-remove {
      background: #fff;
      cursor: pointer;
      transition: all 0.2s ease;
      &:hover {
        background-color: #ddd;
      }
      &:active {
        opacity: 0.8;
      }
      @media screen and (max-width: 768px) {
        // display: none;
        &:hover {
          background: #fff;
        }
      }
    }
    .list-mp-remove {
      top: 10px;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 84px;
      width: 0;
      height: calc(100% - 24px);
      white-space: nowrap;
      color: white;
      border-radius: 5px;
      background-color: red;
      z-index: 1;
      @media screen and (min-width: 768px) {
        width: 0 !important;
      }
    }
  }
}

.cart-discount {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 10px;
  border-top: 1px solid #e8e8e8;
  .discount-left {
    margin-bottom: 10px;
    background-color: #f1f1f1;
    padding: 10px 5px 10px 15px;
    > button {
      margin-left: 10px;
      padding: 0 15px;
      color: white;
      border: none;
      outline: none;
      border-radius: 15px;
      background-color: $btn-color;
      transition: all 0.3s ease;
      &:disabled {
        cursor: not-allowed;
      }
      &:hover {
        background-color: $btn-hover-color;
      }
    }
  }
  .discount-right {
    margin-bottom: 10px;
    font-size: 16px;
    flex: 1;
    text-align: right;
    white-space: nowrap;
    .price {
      margin-left: 40px;
    }
  }
}
.cart-totalPrice {
  padding-top: 15px;
  text-align: right;
  font-size: 16px;
  border-top: 1px solid #e8e8e8;
  .price {
    margin-left: 40px;
  }
}
.purchaseBtn {
  width: 100%;
  font-size: 18px;
  color: white;
  outline: none;
  border: none;
  background-color: $btn-color;
  height: 56px;
  border: 5px;
  transition: all 0.5s ease;
  &:disabled {
    cursor: not-allowed;
  }
  &:hover {
    background-color: $btn-hover-color;
  }
  > i {
    font-size: 24px;
    margin-right: 10px;
  }
}
.cart {
  -webkit-overflow-scrolling: touch;
}

/* vue动画 */
.showBox-enter-active,
.showBox-leave-active {
  transition: all 0.2s;
}
.showBox-enter-to, .showBox-leave /* .right-leave-active below version 2.1.8 */ {
  opacity: 1;
}
.right-enter-active,
.right-leave-active {
  width: 0px !important;
  transition: all 0.2s;
  background-color: red;
  overflow: hidden;
}
.right-enter-to, .right-leave /* .right-leave-active below version 2.1.8 */ {
  width: 45% !important;
  @media screen and (max-width: 768px) {
    width: 80% !important;
  }
}
</style>